export default __webpack_public_path__ + "static/BETA-horiz-454d697d8d1e99126b03df464063da3c.svg";